<template>
  <section class="w-100 mt-5 d-flex align-items-center" :class="bgLink()">
    <b-container>
      <b-row :style="topSpace">
        <b-col lg="6" class="text-left text-white font-family-primary" v-html="htmlLink()" />
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  props: {
    topSpace: {
      type: String,
      required: true
    }
  },
  methods: {
    bgLink() {
      switch (this.$route.name) {
        case "how-it-works":
          return "bg-how-it-works";

        case "about":
          return "bg-about";

        case "sou-lojista":
          return "bg-sou-lojista";
      }
    },
    htmlLink() {
      switch (this.$route.name) {
        case "sou-lojista":
          return `
            <h1 class="font-weight-normal mb-4 text-purple" >A maneira mais <strong>prática e moderna</strong> de comprar carros para a sua loja!</h1>
            <h5 class="font-weight-normal text-purple">E o melhor: <strong>sem pagar</strong> taxas ou mensalidades</h5>
          `;

        case "about":
          return `
            <h1 class="font-weight-normal mb-4 text-purple";">A sua experiência <strong>experiência</strong> é nosso <strong>ponto de partida</strong></h1>
            <h5 class="font-weight-normal text-purple mb-3">A <b>VAAPTY</b> busca inovar o comércio de carros usados através do uso de tecnologia e da humanização do relacionamento com os clientes.</h5>
            <h5 class="font-weight-normal text-purple">Mais que vender carros, <strong>nossa missão é oferecer uma solução completa</strong> às pessoas que precisam vender seus veículos com <strong>agilidade e segurança, sem burocracia.</strong></h5>
          `;

        case "how-it-works":
          return `
            <h1 class="font-weight-bold mb-4">Como funciona</h1>
            <h5 class="font-weight-normal">
              Você já pensou em vender seu carro em um VAAPTY!? 
              <br> Sem perder tempo, correr riscos e sem ter que ouvir propostas furadas?
            </h5>
            <h5 class="font-weight-normal">
              Pois isso já é realidade aqui na <strong>VAAPTY!</strong>
            </h5>
            <h5 class="font-weight-normal">
              São poucos passos até que você tenha a melhor oferta do Brasil em seu carro, veja como funciona:
            </h5>
          `;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
section {
  min-height: 80vh;
}

.bg-shopkeeper {
  background-image: url("./../assets/images/bg-pages/bg-1.png");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.bg-about {
  background-image: url("./../assets/images/bg-pages/bg-quem-somos.jpg");
  background-position: center top;
  background-size: cover;
  background-repeat: no-repeat;
}

.bg-how-it-works {
  background-image: url("./../assets/images/bg-pages/bg-como-funciona.jpg");
  background-position: center top;
  background-size: cover;
  background-repeat: no-repeat;
}

.bg-sou-lojista {
  background-image: url("./../assets/images/bg-pages/bg-sou-lojista.jpg");
  background-position: center top;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
